module.exports = __webpack_public_path__ + "85f4cc9316cd4e7de838caff4f49e9bb.png";